import { Component, OnDestroy, OnInit } from '@angular/core';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';

import { AppState } from '../../store/app.reducers';
import { AuthState } from '../../store/reducers';
import { RouteLink } from './route-link';
import { Store } from '@ngrx/store';
import * as authActions from '../../store/actions/index';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public faPowerOff = faPowerOff;
  public loading: boolean;
  public routing: RouteLink[];

  constructor(private store: Store<AppState>) {
    this.loading = false;
    this.routing = [];
  }

  public ngOnInit(): void {
    this.store.select('auth')
    .subscribe((authData: AuthState) => {
      this.loading = authData.loading;
      this.routing = authData.routes;
    });
  }


  public logout(): void {
    this.store.dispatch(authActions.logOutAction());
  }
}
